import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyContactCacheService {
  // A HashMap to store the cache. The key is the page and the value is the data.
  private cache = new Map<string, Observable<any>>();
  private ttlCache = new Map<string, number>();

  // The 'set' method for storing data in the cache.
  set(key: string, data: Observable<any>, ttl = 0): void {
    this.cache.set(key, data);
    if (ttl > 0) {
      this.ttlCache.set(key, Date.now() + ttl);
    }
  }

  // The 'get' method for retrieving data from the cache.
  get(key: string): Observable<any> | undefined {
    const ttl = this.ttlCache.get(key);
    if (ttl && ttl > 0 && ttl < Date.now()) {
      this.clear(key);
    }

    // We retrieve the data from the cache
    return this.cache.get(key);
  }

  // The 'clear' method to clear data from the cache.
  clear(key: string): void {
    // We remove the data from the cache
    this.cache.delete(key);
  }
}
